import React, { useState } from 'react';
import BlueButton2 from './BlueButton2';
import './BlogomatPopupForm.css';

const DEFAULT_PACKAGES = [
    { value: 'Start 360', label: 'Start 360 — 10 posts / 150 € / month' },
    { value: 'Tempo 360', label: 'Tempo 360 — 20 posts / 200 € / month' },
    { value: 'SEO Pro 360', label: 'SEO Pro 360 — 30 posts / 300 € / month' },
    { value: 'Scale 360', label: 'Scale 360 — 90+ posts / 700 € / month' },
];

function BlogomatPopupForm({ isOpen, onClose, title = 'Get Started with Blogomat 360°', packages = DEFAULT_PACKAGES, formType = 'blogomat-popup' }) {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [selectedPackage, setSelectedPackage] = useState('');
    const [message, setMessage] = useState('');
    const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!firstName || !lastName || !email) {
            alert('Please fill in all required fields.');
            return;
        }

        if (!privacyPolicyAccepted) {
            alert('Please accept the Privacy Policy and cookies before submitting the form.');
            return;
        }

        const fd = new FormData();
        fd.append('formType', formType);
        fd.append('firstName', firstName);
        fd.append('lastName', lastName);
        fd.append('email', email);
        fd.append('ContactNumber', phone);
        fd.append('whatSource', selectedPackage);
        fd.append('yourMessage', message);

        fetch('https://marketingv8.co/contact.php', {
            mode: 'no-cors',
            method: 'POST',
            body: fd,
        })
            .then(() => {
                setSubmitted(true);
            })
            .catch((error) => {
                console.error('An error occurred while sending the form:', error);
            });
    };

    const handleClose = () => {
        onClose();
        setSubmitted(false);
        setFirstName('');
        setLastName('');
        setEmail('');
        setPhone('');
        setSelectedPackage('');
        setMessage('');
        setPrivacyPolicyAccepted(false);
    };

    if (!isOpen) return null;

    return (
        <div className='blogomat-popup-overlay' onClick={handleClose}>
            <div className='blogomat-popup-container' onClick={(e) => e.stopPropagation()}>
                {submitted ? (
                    <div className='blogomat-popup-success'>
                        <h2>Thank you! 🎉</h2>
                        <p>Your message has been sent. We'll be in touch soon.</p>
                        <button className='blogomat-popup-close-btn' onClick={handleClose}>Close</button>
                    </div>
                ) : (
                    <form className='blogomat-popup-form' onSubmit={handleSubmit}>
                        <div className='blogomat-popup-header'>
                            <h2 className='blogomat-popup-title'>{title}</h2>
                            <span className='blogomat-popup-x' onClick={handleClose}>✕</span>
                        </div>
                        <p className='blogomat-popup-subtitle'>Fill in the form and we'll get back to you shortly.</p>

                        <div className='blogomat-popup-row'>
                            <div className='blogomat-popup-field'>
                                <label className='blogomat-popup-label'>First name *</label>
                                <input
                                    className='blogomat-popup-input'
                                    placeholder='Enter first name'
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                            </div>
                            <div className='blogomat-popup-field'>
                                <label className='blogomat-popup-label'>Last name *</label>
                                <input
                                    className='blogomat-popup-input'
                                    placeholder='Enter last name'
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className='blogomat-popup-row'>
                            <div className='blogomat-popup-field'>
                                <label className='blogomat-popup-label'>E-mail *</label>
                                <input
                                    className='blogomat-popup-input'
                                    type='email'
                                    placeholder='Enter e-mail'
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                            <div className='blogomat-popup-field'>
                                <label className='blogomat-popup-label'>Phone number</label>
                                <input
                                    className='blogomat-popup-input'
                                    placeholder='+1 212-555-1234'
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className='blogomat-popup-field blogomat-popup-field-full'>
                            <label className='blogomat-popup-label'>Package</label>
                            <select
                                className='blogomat-popup-input blogomat-popup-select'
                                value={selectedPackage}
                                onChange={(e) => setSelectedPackage(e.target.value)}
                            >
                                <option value=''>-- Select a package --</option>
                                {packages.map((pkg) => (
                                    <option key={pkg.value} value={pkg.value}>{pkg.label}</option>
                                ))}
                            </select>
                        </div>

                        <div className='blogomat-popup-field blogomat-popup-field-full'>
                            <label className='blogomat-popup-label'>Additional message</label>
                            <textarea
                                className='blogomat-popup-input blogomat-popup-textarea'
                                placeholder='Tell us more about your project...'
                                rows={4}
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                            />
                        </div>

                        <div className='blogomat-popup-privacy'>
                            <input
                                type='checkbox'
                                id='blogomatPrivacyPolicy'
                                checked={privacyPolicyAccepted}
                                onChange={(e) => setPrivacyPolicyAccepted(e.target.checked)}
                            />
                            <label htmlFor='blogomatPrivacyPolicy'>
                                I have read and accept the Privacy Policy & Cookie Policy. *
                            </label>
                        </div>

                        <div className='blogomat-popup-submit'>
                            <BlueButton2 text='Order now' type='submit' />
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}

export default BlogomatPopupForm;
